var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fold-view"},[(_vm.isUnfold)?_c('i',{staticClass:"el-icon-s-fold"}):_c('i',{staticClass:"el-icon-s-unfold"})])
}
var staticRenderFns = []

export { render, staticRenderFns }